<tiime-overlay [isLoading]="loading()">
  <div tiimeOverlayHeader>
    Relances du contrat
    @if (editableReminder()) {
      <button
        #overlayAnchor
        tiime-button
        icon
        color="primary"
        tiimeTooltip="Modifier la date de la prochaine relance"
        (click)="openUpdateNextReminderDateOverlay()"
      >
        <mat-icon fontSet="fontastic" fontIcon="icon-ic-modify"></mat-icon>
      </button>
    }
  </div>
  <div tiimeOverlayContent>
    <tiime-timeline>
      @for (reminder of reminders(); track $index) {
        <tiime-timeline-item [color]="reminder.status | statusColor: 'contractReminder'">
          <div tiimeTimelineItemDate>
            {{ reminder.date | date: 'dd/MM/YYYY' }}
            @if (reminder.status === ContractReminderStatus.done) {
              <br />
              à {{ reminder.date | date: 'HH:mm' }}
            }
          </div>
          <div tiimeTimelineItemTitle>
            {{ reminder.status | statusLabel: 'contractReminder' }}
            @if (reminder.external) {
              (hors expert)
            }
          </div>
          @if (reminder.createdBy; as createdBy) {
            <div
              tiimeTimelineItemDescription
              [tiimeTooltip]="createdBy.fullName + ' - ' + createdBy.email"
              tooltipHideWithoutEllipsis
            >
              <span>{{ createdBy.fullName }} - {{ createdBy.email }}</span>
            </div>
          }
        </tiime-timeline-item>
      }
    </tiime-timeline>
    @if (!reminders()?.length && !loading()) {
      <div class="empty-label">Aucune relance en cours</div>
    }
    @if (nextReminderDateModifiedAt()) {
      <span class="infos-label">
        {{ 'Relances ajustées le' | atBy: nextReminderDateModifiedAt() : nextReminderDateModifiedBy()?.fullName }}
      </span>
    }
  </div>
  @if (overlayData().contractStatus === ContractStatus.sent) {
    <div tiimeOverlayFooter>
      <tiime-split-button>
        <button type="button" first-button tiime-button color="accent" raised (click)="addReminder(false)">
          Relancer
        </button>
        <button tiime-button color="accent" raised second-button [matMenuTriggerFor]="dropdownMenu">
          <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-arrow-bottom-12"></mat-icon>
        </button>
        <mat-menu class="split-second-button-dropdown" #dropdownMenu="matMenu" yPosition="below" xPosition="before">
          <div (click)="addReminder(true)" mat-menu-item>Relancer hors Expert</div>
        </mat-menu>
      </tiime-split-button>
    </div>
  }
</tiime-overlay>
